import { Flex, Menu, MenuContent, MenuTrigger, Text } from '@optiaxiom/react';
import {
  IconAgent,
  IconCheckCircleSolid,
  IconCircleXmark,
  IconCodeBranch,
  IconGrid2,
} from '@optimizely/axiom-icons';
import { useDecision } from '@optimizely/react-sdk';

import { AgentStatus, AgentType } from '../../../hooks/useAgentsUrlParams';

type AgentFiltersProps = {
  agentType?: AgentType;
  status?: AgentStatus;
  onAgentTypeChange: (type?: AgentType) => void;
  onStatusChange: (status?: AgentStatus) => void;
};

export function AgentFilters({
  agentType,
  status,
  onAgentTypeChange,
  onStatusChange,
}: AgentFiltersProps) {
  const [workflowAgentFeature] = useDecision('workflow-agent');

  const getTypeLabel = () => {
    switch (agentType) {
      case 'specialized':
        return 'Specialized';
      case 'workflow':
        return workflowAgentFeature.enabled ? 'Workflow' : 'All Types';
      default:
        return 'All';
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      default:
        return 'All';
    }
  };

  const agentTypeOptions = [
    {
      label: 'All',
      execute: () => onAgentTypeChange(undefined),
      addon: <IconGrid2 />,
    },
    {
      label: 'Specialized',
      execute: () => onAgentTypeChange('specialized'),
      addon: <IconAgent />,
    },
  ];

  if (workflowAgentFeature.enabled) {
    agentTypeOptions.push({
      label: 'Workflow',
      execute: () => onAgentTypeChange('workflow'),
      addon: <IconCodeBranch />,
    });
  }

  const statusOptions = [
    {
      label: 'All',
      execute: () => onStatusChange('all'),
      addon: <IconGrid2 />,
    },
    {
      label: 'Active',
      execute: () => onStatusChange('active'),
      addon: <IconCheckCircleSolid />,
    },
    {
      label: 'Inactive',
      execute: () => onStatusChange('inactive'),
      addon: <IconCircleXmark />,
    },
  ];

  return (
    <>
      <Menu options={agentTypeOptions}>
        <MenuTrigger h="40">
          <Flex gap="0">
            <Text textAlign="start" fontSize="sm">
              Type
            </Text>
            <Text textAlign="start" fontSize="xs">
              {getTypeLabel()}
            </Text>
          </Flex>
        </MenuTrigger>
        <MenuContent />
      </Menu>

      <Menu options={statusOptions}>
        <MenuTrigger h="40">
          <Flex gap="0">
            <Text textAlign="start" fontSize="sm">
              Status
            </Text>
            <Text textAlign="start" fontSize="xs">
              {getStatusLabel()}
            </Text>
          </Flex>
        </MenuTrigger>
        <MenuContent />
      </Menu>
    </>
  );
}
